import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AwsService } from '../../../providers/appsyncservice/aws.service';
import { UserTypePipePipe } from '../../../pipes/user-type-pipe.pipe';
import { positions } from '../../../models/positions';
declare var google: any;
import * as XLSX from 'xlsx';
import * as jsPDF from 'jspdf';

@Component({
  selector: 'app-rnc-users',
  templateUrl: './rnc-users.component.html',
  styleUrls: ['./rnc-users.component.css']
})
export class RncUsersComponent implements OnInit {


  userlist: any = [];
  cnt : number =0;
  usertypes: any;
  sosstatus: any[] = [];
  disbaleUpdate: boolean = false;
  nextToken: String = "";
  cabs: any = [];
  scheduled_date: String = '';
  user_name: String = '';

  key: string = 'user_name'; //set default
  reverse: boolean = false;

  typeList: any = [];
  statusList: any = [];
  userForm: FormGroup;
  submitted: boolean = false;
  errorMessage: string;
  errorType: boolean = false;
  id: String = "";

  displayValue: Number = 0;
  cabmaster: any;
  driverusers: any;
  driverDropdownSettings = {};

  user_type: string;


  constructor(public awserviceProvider: AwsService,
    private formBuilder: FormBuilder) {
   this.getAllData();
 }

  getAllData() {

    let filter : any ={};
    filter.user_type="2" 
    filter.user_name  ="";
    this.search(filter);

    // this.awserviceProvider.RncUsersAll().then(userslist => {

    //   this.userlist = userslist;
    //   this.userlist.sort();

    // }).catch(err => {
    //   console.log('err', err)
    // })
  }



  ngOnInit() {
    this.usertypes = [
      { id: 0, name: "Super Admin" },
      { id: 1, name: "Employee" },
      { id: 2, name: "Driver" },
      { id: 3, name: "Personal Driver" },
      { id: 4, name: "Driver Attendance Admin" }
    ]
    this.sosstatus = [
      { id: 0, name: "No" },
      { id: 1, name: "Yes" },
    ]
    this.cnt=0;

    // this.editvehicle={};

    this.displayValue = 0;
    this.user_name = "";
    this.user_type = "2";
    this.scheduled_date = "";
    this.driverusers = [];
    this.cabs = [];
    this.driverDropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'id',
      itemsShowLimit: 5,
      allowSearchFilter: true
    };



    this.formInitilization();

  }

  formInitilization() {
    this.userForm = new FormGroup({
      id: new FormControl(""),
      emergency_phone: new FormControl('', Validators.required),
      employee_phone: new FormControl('', Validators.required),
      home_address: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      //  password: new FormControl('', Validators.required),
      profile_image: new FormControl(""),
      user_name: new FormControl('', Validators.required),
      user_type: new FormControl('', Validators.required),
      sos_enabled: new FormControl('', Validators.required)

    });
  }

  get f() { return this.userForm.controls; }

  async onSubmit() {
    // alert(this.userForm.invalid)
    this.submitted = true;
    console.log(this.userForm)
    if (this.userForm.invalid) {
      return;
    }
    this.disbaleUpdate = true;

    await this.getGeoLocation(this.userForm.value.home_address).then(async st => {
      let stposition: any = {};
      stposition.lat = st.latitude;
      stposition.long = st.longitude;

      this.awserviceProvider.updateRncUsers(this.userForm.value, stposition).then(res => {
        this.displayValue = 0;
        this.getAllData();
      }).catch(err => {
        this.errorType = true;
        console.log(err);

      });

    }).catch(err => {
      this.errorType = true;
      console.log(err);
    });

  }


  search(searchData) {

    this.nextToken = "";
    this.searchFilter(searchData);
  }



  searchFilter(searchData) {

  
    if (this.nextToken == "") { this.userlist = []; this.cnt=0;}

    this.awserviceProvider.SearchRncUsers(searchData, this.nextToken).then((userslist : any) => {
      console.log("userslist",userslist)
      if (userslist.nextToken != null) {
        this.nextToken = userslist.nextToken;
        this.searchFilter(searchData);
      }
console.log(" this.nextToken", this.nextToken)
      userslist.items.forEach(user => {
        this.cnt++;
        user.cnt=this.cnt;
        this.userlist.push(user);
       
      });

      this.userlist.sort();

    }).catch(err => {
      console.log('err', err)
    })


  }


  editData(userData: any) {

    this.displayValue = 1;
    this.disbaleUpdate = false;
    this.id = userData.id;
    this.userForm.setValue(
      {
        id: userData.id,
        emergency_phone: userData.emergency_phone.replace('+91', ''),
        employee_phone: userData.employee_phone.replace('+91', ''),
        home_address: userData.home_address.address,
        name: userData.name,
        //password: userData.password,
        profile_image: userData.profile_image,
        user_name: userData.user_name,
        user_type: userData.user_type,
        sos_enabled: userData.sos_enabled

      });

    //  console.log("  this.editvehicle", this.editvehicle)

  }

  setName(name) {
    this.user_name = name;
    // alert(name);
  }

  deleteData(vhcl) {

    // this.awserviceProvider.updateVehicleMstStatus(vhcl.id, 1).then(res => {
    //      this.getAllData()

    // }).catch(err => {

    //   console.log(err);
    // });
  }

  add() {

    this.formInitilization();


    this.displayValue = 1;

  }


  async getGeoLocation(address: string): Promise<any> {
    console.log('address', address)
    let myPromise = await new Promise((resolve, reject) => {
      setTimeout(() => {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': address }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var lat = results[0].geometry.location.lat();
            var lng = results[0].geometry.location.lng();
            // // console.log("lat", lat)
            // // console.log("lat", lng)
            var pos = new positions;
            pos.latitude = lat;
            pos.longitude = lng;
            resolve(pos)
            console.log('GeoLocation found')
          } else {
            console.log("geo locaton status error--", status, results)
            reject(status)
          }
        });
      }, 2300);
    })
    return myPromise
  }


  exportToExcel() {
    let exportJsonTemp = [];

    exportJsonTemp = this.exportJsonFormation(this.userlist);
    const workBook = XLSX.utils.book_new(); // create a new blank book

    const workSheet = XLSX.utils.json_to_sheet(exportJsonTemp);

    // console.log("EXCEL", exportJsonTemp);
    XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
    XLSX.writeFile(workBook, 'SafeCab Users.xlsx');


  }

  exportToPdf() {
    console.log("exportToPdf")
    //this.spinnerService.show();
    var getColumns = [
      { title: "S NO", dataKey: "sno" },
      { title: "User ID", dataKey: "user_name" },
      { title: "User Name", dataKey: "name" },
      { title: "Type", dataKey: "user_type" },
      { title: "Employee Phone", dataKey: "employee_phone" },
      { title: "Emergency Phone", dataKey: "emergency_phone" },
      { title: "SOS Enabled", dataKey: "sos_enabled" },
      { title: "Home Address", dataKey: "home_address" }
    ];

    var pdfsize = 'a4';
    var doc = new jsPDF('l', 'pt', pdfsize);

    doc.text(20, 20, 'SAFECab Users');
    let exportJsonTemp = [];
    exportJsonTemp = this.exportJsonFormation(this.userlist);
    doc.autoTable(getColumns, exportJsonTemp, {
      startY: 40,
      // startX: 20,
      tableLineColor: [189, 195, 199],
      tableLineWidth: 0.75,
      styles: {
        font: 'Times New Roman',
        fillColor: [217, 217, 217],
        lineColor: [189, 195, 199],
        lineWidth: 0.25,
        textColor: 0,
      },
      headerStyles: {fillColor: [217, 217, 217],textColor: 0},
      columnStyles: {
        text: { overflow: 'linebreak' },
        name: {cellWidth: 50,overflow: 'linebreak'},
        employee_phone: {cellWidth: 50,overflow: 'linebreak'},
        emergency_phone: {cellWidth: 50,overflow: 'linebreak'},
        sos_enabled: {cellWidth: 50,overflow: 'linebreak'},
        user_type: {cellWidth: 50,overflow: 'linebreak'},
        home_address: {cellWidth: 120,overflow: 'linebreak'}
      }


    })
    doc.save("SAFECab Users.pdf");
  }


  exportJsonFormation(users) {
    let dateFormat = require('dateformat');
    let exportJsonTemp = [];

    users.forEach(user => {
      let exJson: any = {};
      exJson.sno = user.cnt;
      exJson.user_name = user.user_name;
      exJson.name = user.name;
      exJson.user_type = this.UserTypes(user.user_type);
      exJson.employee_phone = user.employee_phone.replace('+91', '');
      exJson.emergency_phone = user.emergency_phone.replace('+91', '');
      exJson.sos_enabled = user.sos_enabled == 1 ? 'Yes' : 'No';
      exJson.home_address = user.home_address != null ? user.home_address.address : '';
      exportJsonTemp.push(exJson);
    });

    return exportJsonTemp;

  }

  UserTypes(value) {
    if (value == 0) { return "Super Admin"; }
    else if (value == 1) { return "Employee"; }
    else if (value == 2) { return "Driver"; }
    else if (value == 3) { return "Personal Driver"; }
    else if (value == 4) { return "Driver Attendance Admin"; }
    else return "";
  }


  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }



}
